import socketIOClient from "socket.io-client";
import toastr from 'toastr';
import 'toastr/build/toastr.css';
import { CODE_SNIPPET, LAYOUT_SETTINGS, SITE_NOTIFICATION, NOTIFICATION_MESSAGE_TYPE } from "../constants/CoreConstants";

/**
 * Handle error exception
 *
 * @param Error error
 * @param Function/null callback
 */
import { getCookie, getCookieLogin, setCookieLogin } from "./Cookie";
import { getCodeSnippet } from "../api/globalApi";
import { fetchLoginPageData } from "../api/loginApi";
import { US_STATE_LIST, PHONE_STATE } from "../components/GlobalContactDetailsForDeal/RightSide/helper/core_constant";
import { renderToString } from "react-dom/server";
import { DefaultIcons } from "../components/layouts/NotificationIcons";
import { SCAM_KEYWORDS, SOCKET_NOTIFICATION_ACTIONS } from "./CoreConstant";



const handleException = (error) => {
    console.error(error);

    // to do
}

/**
 * Get contact's display name
 * 
 * @param string name 
 * @param string number 
 * @param string email 
 * @returns string
 */
const getContactDisplayName = (name, number, email, full = false) => {
    if (name === undefined || name === null || name.trim() === '' || name === 'null null') {
        if (number === undefined || number === null || number.trim() === '') {
            if (email === undefined || email === null || email.trim() === '') {
                return '[No Name]';
            } else {
                return email.length > 15 && !full ? email.substr(0, 13) + ' ...' : email;
            }
        } else {
            return number;
        }
    }
    name = name.trim()
    return name.length > 15 && !full ? name.substr(0, 13) + ' ...' : name;
}

const getShorterText = (text, length = 15) => {
    return text.length > length ? text.substr(0, length - 3) + ' ...' : text;
}

export const getStateObj = (value) => US_STATE_LIST.find((state) => state.value === value);

/**
 * Display notification
 * 
 * @param string message 
 * @param string type 
 * @param string/null title 
 * @param boolean sticky 
 */
const showNotification = (message = 'Something went wrong', type = 'error') => {
    window.showNotification(type.toUpperCase(), message);
};

/**
 * Get initial of name
 * 
 * @param string name 
 * @returns string
 */
const getInitial = (name, initialCharacter = '') => {
    try {
        if (typeof name != 'undefined') {
            let fullNameInitial = initialCharacter
            if (name === 'null null' || name === '' || name === ' ') {
                fullNameInitial = initialCharacter;
            } else if (name !== 'undefined' || name !== null) {
                fullNameInitial = name.split(" ").map((n, i, a) => i === 0 || i + 1 === a.length ? n[0] : null).join("");
            }
            return fullNameInitial;
        } else {
            return initialCharacter;
        }
    } catch (error) {
        return initialCharacter;
    }
}

export const formatNumber = (number) => {
    if (number) {
        var cleaned = ('' + number).replace(/\D/g, '')
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '')
            return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('')
        }
        return number.replace(/[. \-+()]/g, '');
    } else {
        return number;
    }

}

const loadSocket = (userId) => {
    const socket = socketIOClient(process.env.REACT_APP_NODE_SERVER, {
        resource: 'B/socket.io',
        'force new connection': true
    });

    const userRoom = "room:" + userId;
    const userBackgroundNotificationRoom = "background-task-notification:room:" + userId;

    socket.on('connect', function (data) {
        socket.emit('join-notification-room', userRoom);
        socket.emit('join-background-task-notification-room', userBackgroundNotificationRoom);
    });

    socket.on('notification', function (data) {
        if (getAccountData('new_reply_notify_push_notification')) {
            if (typeof data.params.type !== 'undefined' && (data.params.type == SITE_NOTIFICATION.SMS || data.params.type == SITE_NOTIFICATION.EMAIL || data.params.type == SITE_NOTIFICATION.CALL)) {
                toastr.options = {
                    // "closeButton": true,
                    // "debug": false,
                    // "newestOnTop": false,
                    // "progressBar": false,
                    // "positionClass": "toast-bottom-right",
                    // "preventDuplicates": false,
                    "onclick": typeof data.params.permalink !== 'undefined' && data.params.permalink ? function () { window.location.href = "/contacts/" + data.params.contact_id } : null,
                    // "timeOut": "0",
                    // "extendedTimeOut": "0",
                    // "showEasing": "swing",
                    // "hideEasing": "linear",
                    // "showMethod": "fadeIn",
                    // "hideMethod": "fadeOut"
                };

                toastr.info(data.params.message);
            }

            if (Object.values(NOTIFICATION_MESSAGE_TYPE).includes(parseInt(data.params.type))) {
                if (typeof window.loadInboxThreads === 'function') {
                    window.loadInboxThreads();
                }
                if (typeof window.refreshConersation === 'function') {
                    window.refreshConersation(data.params.contact_id);
                }
                if (typeof window.updateNotificationCount === 'function') {
                    window.updateNotificationCount(true, true);
                }
            }
        }
    });

    socket.on('background-task-notification', function (data) {

        toastr.options = {
            "closeButton": false,
            "debug": false,
            "newestOnTop": false,
            "progressBar": false,
            "positionClass": "toast-bottom-right",
            "preventDuplicates": false,
            "onclick": null,
            "showDuration": "300",
            "hideDuration": "1000",
            "timeOut": "3000",
            "extendedTimeOut": "1000",
            "showEasing": "swing",
            "hideEasing": "linear",
            "showMethod": "fadeIn",
            "hideMethod": "fadeOut"
        };

        if (data.params.action === SOCKET_NOTIFICATION_ACTIONS.DELETE) {
            if (typeof data.params.type !== 'undefined' && data.params.type === 'error') {
                toastr.error(data.params.message);
            } else {
                if (data.params.message !== undefined && data.params.message === "Campaign is started") {
                    // handleSocketForCampaign(data.params.related_id)
                    if (window.campaignStatusSocketProcess !== undefined) {
                        window.campaignStatusSocketProcess(parseInt(data.params.related_id))
                    }
                }
                toastr.success(data.params.message);
            }

        } else if (data.params.action === SOCKET_NOTIFICATION_ACTIONS.INSERT) {
            toastr.info(data.params.message);
        } else if (data.params.action === SOCKET_NOTIFICATION_ACTIONS.FILE_DOWNLOAD) {
            let processId = 'downloadPopupHeader';
            if (isElementInViewport(processId)) {
                mySuccessProcessFunction(data.params.file_name, data.params.file_url);
            } else {
                FileDownloadNotificationHtmlTemplate('DOWNLOAD', 'Your file is ready to download!', data.params.file_url);
            }

        } else if (data.params.action === SOCKET_NOTIFICATION_ACTIONS.VIEW_RESULT) {
            let processId = 'importEnhancePopupHeader';
            if (isElementInViewport(processId)) {
                handleAutoRedirect(data.params.fileSource);
            } else {
                ViewResultNotificationHtmlTemplate('VIEW RESULTS', 'Your data results are ready!', data.params.fileSource);
            }
        } else if (data.params.action === SOCKET_NOTIFICATION_ACTIONS.REDIRECT) {

            let currentURL = window.location.href;

            if (data.params.lookupType === 'DNC_LOOKUP' && currentURL.includes("tab=dnc&page=results")) {
                let pageLink = 'contacts/clean-list?tab=dnc&page=results';
                window.location.href = window.location.origin + '/' + pageLink;
            }

            if (data.params.lookupType === 'CARRIER_LOOKUP' && currentURL.includes("tab=verify&page=results")) {
                let pageLink = 'contacts/clean-list?tab=verify&page=results';
                window.location.href = window.location.origin + '/' + pageLink;
            }

            if (data.params.lookupType === 'EMAIL_LOOKUP' && currentURL.includes("tab=verify&page=results")) {
                let pageLink = 'contacts/clean-list?tab=verify&page=results';
                window.location.href = window.location.origin + '/' + pageLink;
            }
        } else if (data.params.action === SOCKET_NOTIFICATION_ACTIONS.BULK_EMAIL_TRACK_NOTIFICATION) {
            NotificationHtmlTemplate({
                leftIcon: renderToString(<DefaultIcons />),
                text: '',
                des: data.params.message,
                closeText: 'Dismiss',
                timer: 10000,
                classText: 'default',
                redirect: `/contacts/${data.params.related_id}`
            });
        }
        else if (data.params.action === SOCKET_NOTIFICATION_ACTIONS.LEAD_OWNER_CHANGE) {
            NotificationHtmlTemplateV2({
                headerText: 'Notice: Lead Owner Change',
                bodyText: data.params?.message ?? " Lead Owner Update",
                closeBtnText: data.params?.closeBtnText ?? 'View Details',
                timer: 15000,
                closeButtonLink: `/contacts/${data.params.contactId}`,
                leftIcon: renderToString(<DefaultIcons />),
            });
        }
        else if (data.params.action === SOCKET_NOTIFICATION_ACTIONS.SMART_FORM_SUBMISSION) {

            NotificationHtmlTemplateV2({
                headerText: 'New Form Submission',
                bodyText: data.params?.message?.replace(/\n/g, "<br>") ?? "Form Submission",
                closeBtnText: 'View Details',
                timer: 15000,
                closeButtonLink: data.params?.smartFormId ? `/fbuilder/submission/${data.params.smartFormId}` :
                    '/fbuilder/forms',
                leftIcon: renderToString(<DefaultIcons />),
            });
        }else if (data.params.action === SOCKET_NOTIFICATION_ACTIONS.CUSTOM_NOTIFICATION) {
            NotificationHtmlTemplateV2({
                headerText: data.params?.headerText ? data.params.headerText :  '',
                bodyText: data.params?.message?.replace(/\n/g, "<br>") ?? '',
                closeBtnText: data.params?.closeButtonText ? data.params.closeButtonText : '',
                timer: 15000,
                closeButtonLink: data.params?.link ? data.params.link : null,
                leftIcon: renderToString(<DefaultIcons />),
            });
        }
    });
}

/**
 * Function name: getAccountData
 * This function will provide
 * AuthUserAgencyName
 * packageType
 * starterPack
 * starterProPack
 * standardPack
 * baseUrl
 * userIsAgent
 * userIsOwner
 * userIsAdmin
 * button_text_transform_class
 * userTimezone
 * userTimezoneRaw
 * userId
 * agencyId
 * parentId
 * canvaApiKey
 * fullName
 * email
 * agencyLogo
 * profileImage
 * layoutSettings
 * userOnboard
 * isAgencyMapPackageActive
 * note_edit_access
 * companyName
 * agencyBusinessType
 * trialRemainingDays
 * 
*/
export const getAccountData = (needle) => {
    let accountData = null;
    let check_new = getCookie("encode__process__new")
    if (check_new !== undefined) {
        accountData = getCookieLogin(process.env.REACT_APP_ACCOUNT_DATA);
    } else {
        accountData = getCookie(process.env.REACT_APP_ACCOUNT_DATA);
    }
    if (accountData) {
        accountData = JSON.parse(accountData);
        return accountData[needle];
    }
    return false;
}

export const setLayoutStyles = () => {
    let styles = getAccountData('layoutSettings');
    if (styles !== undefined && styles[LAYOUT_SETTINGS.TOPBAR_BACKGROUND]) {
        document.documentElement.style.setProperty('--topbar-background', styles[LAYOUT_SETTINGS.TOPBAR_BACKGROUND]);
    }
    if (styles !== undefined && styles[LAYOUT_SETTINGS.TOPBAR_TEXT_COLOR]) {
        document.documentElement.style.setProperty('--topbar-text-color', styles[LAYOUT_SETTINGS.TOPBAR_TEXT_COLOR]);
    }
    if (styles !== undefined && styles[LAYOUT_SETTINGS.SIDEBAR_BACKGROUND]) {
        document.documentElement.style.setProperty('--sidebar-background', styles[LAYOUT_SETTINGS.SIDEBAR_BACKGROUND]);
    }
    if (styles !== undefined && styles[LAYOUT_SETTINGS.SIDEBAR_TEXT_COLOR]) {
        document.documentElement.style.setProperty('--sidebar-text-color', styles[LAYOUT_SETTINGS.SIDEBAR_TEXT_COLOR]);
    }
    if (styles !== undefined && styles[LAYOUT_SETTINGS.SIDEBAR_ICON_COLOR]) {
        document.documentElement.style.setProperty('--sidebar-icon-color', styles[LAYOUT_SETTINGS.SIDEBAR_ICON_COLOR]);
    }
    if (styles !== undefined && styles[LAYOUT_SETTINGS.SIDEBAR_HOVER_COLOR]) {
        document.documentElement.style.setProperty('--sidebar-hover-color', styles[LAYOUT_SETTINGS.SIDEBAR_HOVER_COLOR]);
    }
    if (styles !== undefined && styles[LAYOUT_SETTINGS.ACCENT_COLOR]) {
        document.documentElement.style.setProperty('--accent-color', styles[LAYOUT_SETTINGS.ACCENT_COLOR]);
        document.documentElement.style.setProperty('--accent-color-opacity1', hexToRgbA(styles[LAYOUT_SETTINGS.ACCENT_COLOR]));
    }
    if (styles !== undefined && styles[LAYOUT_SETTINGS.ACCENT_TEXT_COLOR]) {
        document.documentElement.style.setProperty('--accent-text-color', styles[LAYOUT_SETTINGS.ACCENT_TEXT_COLOR]);
    }
    if (styles !== undefined && styles[LAYOUT_SETTINGS.SHORT_MENU] !== undefined && styles[LAYOUT_SETTINGS.SHORT_MENU] === "1") {
        if (window.setCollapsedMenu) {
            window.setCollapsedMenu(true);
        }
    } else if (styles !== undefined) {
        if (window.setCollapsedMenu) {
            window.setCollapsedMenu(false);
        }
    }


}

export const hexToRgbA = (hex) => {
    var c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',0.1)';
    }
    return hex;
}

export const isDefaultAgency = (agencyId) => {
    if (parseInt(agencyId) === 1) {
        return true;
    } else {
        return false;
    }
}

const generateTimezoneList = (tzone = null) => {
    let timezone = [
        { 'America/New_York': 'Eastern Time' },
        { 'America/Chicago': 'Central Time' },
        { 'America/Denver': 'Mountain Time' },
        { 'America/Phoenix': 'Arizona Time' },
        { 'America/Los_Angeles': 'Pacific Time' },
        { 'America/Anchorage': 'Alaska Time' },
        { 'Pacific/Honolulu': 'Hawaii Time' },
    ];

    if (tzone) {
        const found = timezone.find(element => Object.getOwnPropertyNames(element)[0] === tzone);

        return found[Object.getOwnPropertyNames(found)];
    }

    return timezone;
}

const loadCodeSnippets = (page, data) => {
    try {
        getCodeSnippet({ page, data }).then(response => {
            if (response.data.status) {
                response.data.codeSnippets.forEach(codeSnippet => {

                    let script = document.createRange().createContextualFragment(codeSnippet.code);
                    let tagName = codeSnippet.position == CODE_SNIPPET.POSITION_HEADER ? 'head' : 'body';
                    document[tagName].append(script);
                })
            }
        }).catch(err => {
            console.log("pypepro-parent-module/src/helpers/Utils.js > loadCodeSnippets > catch")
        });
    } catch (error) {
        console.log("pypepro-parent-module/src/helpers/Utils.js > loadCodeSnippets")
    }
}

const referralTrackingScript = (userEmail) => {
    try {
        const trackingScript = `<script>window.fpr("referral",{email: ${userEmail})</script>`;

        let script = document.createRange().createContextualFragment(trackingScript);
        let tagName = 'head';
        document[tagName].append(script);

    } catch (error) {
        console.log("pypepro-parent-module/src/helpers/Utils.js > referralTrackingScript")
    }
}

const getIconTextFromContact = (contact) => {

    let firstName = (contact.first_name !== undefined && contact.first_name !== null) ? contact.first_name.trim() : ''
    let lastName = (contact.last_name !== undefined && contact.last_name !== null) ? contact.last_name.trim() : ''

    if (firstName !== '' && lastName !== '') {
        return (firstName.substring(0, 1) + lastName.substring(0, 1)).toUpperCase()
    } else if (firstName !== '') {
        return firstName.substring(0, 2).toUpperCase()
    } else if (lastName !== '') {
        return lastName.substring(0, 2).toUpperCase()
    } else {
        return 'N/A'
    }
}

const isEmpty = (text) => {
    return !(text !== undefined && text != null && text !== '');
}

const getContactName = (contact) => {

    let firstName = (contact.first_name !== undefined && contact.first_name != null) ? contact.first_name.trim() : ''
    let lastName = (contact.last_name !== undefined && contact.last_name != null) ? contact.last_name.trim() : ''
    if (firstName === '' && lastName === '') {

        if (!isEmpty(contact.number)) {
            return contact.number
        } else if (!isEmpty(contact.email)) {
            return contact.email
        } else {
            return null
        }
    } else {
        return (firstName + ' ' + lastName).trim()
    }


}

const reduceTextLength = (text, limit = 40) => {
    if (text !== undefined) {
        text = text.toString();
        if (text.length > limit) {
            return text.substring(0, limit);
        } else {
            return text;
        }
    } else {
        return "";
    }

}

const setAgencyTitleAndFav = (title) => {
    document.title = title;
    fetchLoginPageData().then(res => {
        document.title = title + " | " + res.data.data.agencyName;

        var link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.getElementsByTagName('head')[0].appendChild(link);
        }
        link.href = res?.data?.data?.favIcon;
    });
}

const checkLetterExistInText = (text) => {
    var regExp = /[a-zA-Z]/g;
    let result = false
    if (regExp.test(text)) {

        result = true
    }
    return result
}

const checkNumberExistInText = (text) => {
    var regExp = /[0-9]/g;
    let result = false
    if (regExp.test(text)) {

        result = true
    }
    return result
}

const isNaturalNumber = (text) => {
    text = text.toString(); // force the value incase it is not
    let n1 = Math.abs(text),
        n2 = parseInt(text, 10);
    return !isNaN(n1) && n2 === n1 && n1.toString() === text;
}

const create_UUID = () => {
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
    return uuid;
}

const mySuccessProcessFunction = (fileName, fileUrl) => {
    let processId = 'downloadPopupHeader';
    let helpText = 'helpTextPopupModal';
    let successId = 'downloadPopupSuccessHeader';
    let successTextId = 'successTextPopupModal';
    let downloadBtnId = 'downloadPopupModal';

    // Check if the div is initially visible
    if (isElementInViewport(processId)) {
        document.getElementById(processId).classList.add('d-none');
        document.getElementById(helpText).classList.add('d-none');

        document.getElementById(successId).classList.remove('displayHidden');
        document.getElementById(successTextId).classList.remove('displayHidden');
        document.getElementById(downloadBtnId).classList.remove('displayHidden');
        let element = document.getElementById(successId);
        element.style.display = 'block';
        element.style.textAlign = 'center';

        let element2 = document.getElementById(successTextId);
        element2.style.display = 'block';
        element2.style.textAlign = 'center';

        let element3 = document.getElementById(downloadBtnId);
        element3.style.display = 'block';

        document.getElementById("downloadFileName").textContent = fileName;

        var downloadButton = document.getElementById('downloadPopupModal');
        downloadButton.addEventListener('click', function () {
            var pdfUrl = fileUrl;
            var anchor = document.createElement('a');
            anchor.href = pdfUrl;
            anchor.download = 'your-pdf-file.pdf';
            anchor.click();

            var myButton = document.getElementById('closeDownloadPopUp');
            setTimeout(function () {
                myButton.click();
            }, 1000);
        });

    } else {

    }
}

function handleAutoRedirect(newLink) {
    let pageLink = '';
    switch (newLink) {
        case "ALL":
            pageLink = 'contacts/clean-list?page=imports&open=new';
            break;
        case "CARRIER":
            pageLink = 'contacts/clean-list?tab=verify&page=imports&open=new';
            break;
        case "DNC":
            pageLink = 'contacts/clean-list?tab=dnc&page=imports&open=new';
            break;
        case "SKIP_TRACE":
            pageLink = 'contacts/clean-list?tab=skiptracing&page=imports&open=new';
            break;
        default:
            pageLink = 'contacts/clean-list';
    }
    window.location.href = window.location.origin + '/' + pageLink;

};


function isElementInViewport(elementId) {
    var el = document.getElementById(elementId);
    if (!el) return false; // Return false if element is not found
    var rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

export const FileDownloadNotificationHtmlTemplate = (buttonText, message, link) => {
    let leftIcon = 'default';
    let closeText = '';
    let timer = 10000;
    let classText = 'info';
    let new_interval = '', container = '';
    function handleOnCloseFileDownloadNotification() {
        clearInterval(new_interval)
        new_interval = '';
        container.classList.add('pypepro_file_download_nt_hide');
    }

    function handleDownload() {
        let input = document.getElementById("download_link_input")
        let newLink = input.value;
        window.open(newLink, '_blank');
    };

    let element_exist = document.getElementById("pypepro_notification_file_download_wrp_id");
    if (element_exist) {
        if (element_exist.getAttribute('interval')) {
            clearInterval(element_exist.getAttribute('interval'))
            element_exist.setAttribute('interval', null)
        }
        if (!element_exist.classList.contains(classText)) {
            element_exist.classList.remove('info')
            element_exist.classList.remove('error')
            element_exist.classList.remove('success')
            element_exist.classList.remove('warning')
            element_exist.classList.remove('default')
            element_exist.classList.add(classText)
        }
        // document.getElementById("download_link_input").value = link;

        element_exist.classList.remove('pypepro_file_download_nt_hide')
        if (element_exist.classList.contains('pypepro_nt_replace')) {
            element_exist.classList.remove('pypepro_nt_replace')
        }
        else {
            element_exist.classList.add('pypepro_nt_replace')
        }
        setTimeout(() => {
            try {
                /* icon */
                let icon_span = element_exist.querySelector('span[id=pypepro_nt_li_file_download_wrp_id]');
                if (icon_span) {
                    icon_span.innerHTML = leftIcon
                }
                /* v2 */
                let message_span_v2 = element_exist.querySelector('input[id=download_link_input]');
                if (message_span_v2) {
                    message_span_v2.value = link
                }
                /* text */
                let message_span = element_exist.querySelector('span[id=pypepro_nt_info_file_download_wrp_id]');
                if (message_span) {
                    message_span.innerHTML = `<b>${buttonText}</b> ${message}`
                }
                /* dismiss */
                let dismiss_span = element_exist.querySelector('span[id=pypepro_nt_close_file_download_wrp_id]');
                if (dismiss_span) {
                    dismiss_span.innerText = closeText
                }
                new_interval = setTimeout(() => {
                    try {
                        element_exist.classList.add('pypepro_file_download_nt_hide');
                    }
                    catch (error) { }
                }, timer);
                element_exist.setAttribute('interval', new_interval)
            }
            catch (error) { }
        }, 500);
    }
    else {
        const elm = `
      <div class='customToasterContent show'>
          <div class="customToasterMessage">${message}</div>
          <div class="customToasterActions">
            <input value="${link}" hidden id="download_link_input">
            <button id="custom_file_download" class="customToasterDownload" >${buttonText}</button>
            <button id="pypepro_nt_close_file_download_wrp_id" class="customToasterCancel" >CLOSE</button>
          </div>
    </div>
    `
        container = document.createElement('div')
        container.className = "pypepro_notification_template"
        container.className = classText
        container.id = "pypepro_notification_file_download_wrp_id"
        container.innerHTML = elm
        document.body.appendChild(container)
        // document.getElementById("download_link_input").value = link;

        setTimeout(() => {
            container.classList.add('animate')
            // document.getElementById("download_link_input").value = link;
        }, 0);

        if (document.getElementById("pypepro_nt_close_file_download_wrp_id")) {
            document.getElementById("pypepro_nt_close_file_download_wrp_id").addEventListener('click', handleOnCloseFileDownloadNotification)
        }

        if (document.getElementById("custom_file_download")) {
            document.getElementById("custom_file_download").addEventListener('click', handleDownload)
        }

        new_interval = setTimeout(() => {
            try {
                if (document.getElementById("pypepro_nt_close_file_download_wrp_id")) {
                    document.getElementById("pypepro_nt_close_file_download_wrp_id").removeEventListener('click', handleOnCloseFileDownloadNotification)
                }
                // container.classList.add('pypepro_file_download_nt_hide');
                let element_exist = document.getElementById("pypepro_notification_file_download_wrp_id");
                if (element_exist) {
                    element_exist.remove();
                }

            }
            catch (error) { }
        }, timer);
        container.setAttribute('interval', new_interval)
    }
}

export const ViewResultNotificationHtmlTemplate = (buttonText, message, link) => {
    let leftIcon = 'default';
    let closeText = '';
    let timer = 10000;
    let classText = 'info';
    let new_interval = '', container = '';
    function handleOnCloseViewResultNotification() {
        clearInterval(new_interval)
        new_interval = '';
        container.classList.add('pypepro_view_result_nt_hide');
    }

    function handleDownload() {

        let input = document.getElementById("view_result_input")
        let newLink = input.value;
        let pageLink = '';
        switch (newLink) {
            case "ALL":
                pageLink = 'contacts/clean-list?page=imports&open=new';
                break;
            case "CARRIER":
                pageLink = 'contacts/clean-list?tab=verify&page=imports&open=new';
                break;
            case "DNC":
                pageLink = 'contacts/clean-list?tab=dnc&page=imports&open=new';
                break;
            case "SKIP_TRACE":
                pageLink = 'contacts/clean-list?tab=skiptracing&page=imports&open=new';
                break;
            default:
                pageLink = 'contacts/clean-list';
        }
        window.location.href = window.location.origin + '/' + pageLink;

    };

    let element_exist = document.getElementById("pypepro_notification_view_result_wrp_id");
    if (element_exist) {
        if (element_exist.getAttribute('interval')) {
            clearInterval(element_exist.getAttribute('interval'))
            element_exist.setAttribute('interval', null)
        }
        if (!element_exist.classList.contains(classText)) {
            element_exist.classList.remove('info')
            element_exist.classList.remove('error')
            element_exist.classList.remove('success')
            element_exist.classList.remove('warning')
            element_exist.classList.remove('default')
            element_exist.classList.add(classText)
        }

        element_exist.classList.remove('pypepro_view_result_nt_hide')
        if (element_exist.classList.contains('pypepro_nt_replace')) {
            element_exist.classList.remove('pypepro_nt_replace')
        }
        else {
            element_exist.classList.add('pypepro_nt_replace')
        }
        setTimeout(() => {
            try {
                /* icon */
                let icon_span = element_exist.querySelector('span[id=pypepro_nt_li_view_result_wrp_id]');
                if (icon_span) {
                    icon_span.innerHTML = leftIcon
                }
                /* v2 */
                let message_span_v2 = element_exist.querySelector('input[id=view_result_input]');
                if (message_span_v2) {
                    message_span_v2.value = link
                }
                /* text */
                let message_span = element_exist.querySelector('span[id=pypepro_nt_info_view_result_wrp_id]');
                if (message_span) {
                    message_span.innerHTML = `<b>${buttonText}</b> ${message}`
                }
                /* dismiss */
                let dismiss_span = element_exist.querySelector('span[id=pypepro_nt_close_view_result_wrp_id]');
                if (dismiss_span) {
                    dismiss_span.innerText = closeText
                }
                new_interval = setTimeout(() => {
                    try {
                        element_exist.classList.add('pypepro_view_result_nt_hide');
                    }
                    catch (error) { }
                }, timer);
                element_exist.setAttribute('interval', new_interval)
            }
            catch (error) { }
        }, 500);
    }
    else {
        const elm = `
      <div class='customToasterContent show'>
          <div class="customToasterMessage">${message}</div>
          <div class="customToasterActions">
            <input value="${link}" hidden id="view_result_input">
            <button id="custom_view_result" class="customToasterDownload" >${buttonText}</button>
            <button id="pypepro_nt_close_view_result_wrp_id" class="customToasterCancel" >CLOSE</button>
          </div>
    </div>
    `
        container = document.createElement('div')
        container.className = "pypepro_notification_template"
        container.className = classText
        container.id = "pypepro_notification_view_result_wrp_id"
        container.innerHTML = elm
        document.body.appendChild(container)
        // document.getElementById("download_link_input").value = link;

        setTimeout(() => {
            container.classList.add('animate')
            // document.getElementById("download_link_input").value = link;
        }, 0);

        if (document.getElementById("pypepro_nt_close_view_result_wrp_id")) {
            document.getElementById("pypepro_nt_close_view_result_wrp_id").addEventListener('click', handleOnCloseViewResultNotification)
        }

        if (document.getElementById("custom_view_result")) {
            document.getElementById("custom_view_result").addEventListener('click', handleDownload)
        }

        new_interval = setTimeout(() => {
            try {
                if (document.getElementById("pypepro_nt_close_view_result_wrp_id")) {
                    document.getElementById("pypepro_nt_close_view_result_wrp_id").removeEventListener('click', handleOnCloseViewResultNotification)
                }
                // container.classList.add('pypepro_view_result_nt_hide');
                let element_exist = document.getElementById("pypepro_notification_view_result_wrp_id");
                if (element_exist) {
                    element_exist.remove();
                }

            }
            catch (error) { }
        }, timer);
        container.setAttribute('interval', new_interval)
    }
}



export const NotificationHtmlTemplate = ({ leftIcon = '', text = 'Your file is ready to download!', des = 'description', closeText = 'default', onClose = () => { }, timer = 3000, classText = 'info', redirect = '' }) => {
    let new_interval = '', container = '';
    function handleOnCloseNotification(event) {
        event.stopPropagation();
        clearInterval(new_interval)
        new_interval = ''
        container.classList.add('pypepro_nt_hide');
        onClose()
    }
    let element_exist = document.getElementById("pypepro_notification_wrp_id");
    if (element_exist) {
        element_exist.addEventListener('mouseover', () => {
            clearInterval(new_interval);
        });

        element_exist.addEventListener('mouseout', () => {
            new_interval = setTimeout(() => {
                try {
                    element_exist.classList.add('pypepro_nt_hide');
                }
                catch (error) { }
            }, 1000);
        });

        if (element_exist.getAttribute('interval')) {
            clearInterval(element_exist.getAttribute('interval'))
            element_exist.setAttribute('interval', null)
        }
        if (!element_exist.classList.contains(classText)) {
            element_exist.classList.remove('info')
            element_exist.classList.remove('error')
            element_exist.classList.remove('success')
            element_exist.classList.remove('warning')
            element_exist.classList.remove('default')
            element_exist.classList.add(classText)
        }
        element_exist.classList.remove('pypepro_nt_hide')
        if (element_exist.classList.contains('pypepro_nt_replace')) {
            element_exist.classList.remove('pypepro_nt_replace')
        }
        else {
            element_exist.classList.add('pypepro_nt_replace')
        }
        setTimeout(() => {
            try {
                /* icon */
                let icon_span = element_exist.querySelector('span[id=pypepro_nt_li_wrp_id]');
                if (icon_span) {
                    icon_span.innerHTML = leftIcon
                }
                /* text */
                let message_span = element_exist.querySelector('span[id=pypepro_nt_info_wrp_id]');
                if (message_span) {
                    message_span.innerHTML = `
                        <span class="pypepro_nt_text">${text}</span>
                        <span class="pypepro_nt_des">${des}</span>
                    `
                }
                /* dismiss */
                let dismiss_span = element_exist.querySelector('span[id=pypepro_nt_close_wrp_id]');
                if (dismiss_span) {
                    dismiss_span.innerText = closeText
                }
                new_interval = setTimeout(() => {
                    try {
                        element_exist.classList.add('pypepro_nt_hide');
                    }
                    catch (error) { }
                }, timer);

                if (redirect) {
                    element_exist.addEventListener('click', (event) => {
                        event.stopPropagation();
                        clearInterval(new_interval);
                        new_interval = '';
                        element_exist.classList.add('pypepro_nt_hide');
                        onClose();
                        window.open(redirect, "_self");
                    });
                }

                element_exist.setAttribute('interval', new_interval)
            }
            catch (error) { }
        }, 500);
    }
    else {
        const elm = `
      <div class="pypepro_nt_left_wrp" id="pypepro_nt_left_wrp_id">
        <span class="pypepro_nt_li_wrp" id="pypepro_nt_li_wrp_id">${leftIcon}</span>
        <span class="pypepro_nt_info_wrp" id="pypepro_nt_info_wrp_id">
            <span class="pypepro_nt_text">${text}</span>
            <span class="pypepro_nt_des">${des}</span>
        </span>
      </div>
      <span class="pypepro_nt_close_wrp" id="pypepro_nt_close_wrp_id">${closeText}</span>
    `
        container = document.createElement('div')
        container.className = "pypepro_notification_template"
        container.className = classText
        container.id = "pypepro_notification_wrp_id"
        container.innerHTML = elm
        document.body.appendChild(container)

        setTimeout(() => {
            container.classList.add('animate')
        }, 0);

        if (document.getElementById("pypepro_nt_close_wrp_id")) {
            document.getElementById("pypepro_nt_close_wrp_id").addEventListener('click', handleOnCloseNotification)
        }

        new_interval = setTimeout(() => {
            try {
                if (document.getElementById("pypepro_nt_close_wrp_id")) {
                    document.getElementById("pypepro_nt_close_wrp_id").removeEventListener('click', handleOnCloseNotification)
                }
                // container.classList.add('pypepro_nt_hide');
                let element_exist = document.getElementById("pypepro_notification_wrp_id");
                if (element_exist) {
                    element_exist.remove();
                }

            }
            catch (error) { }
        }, timer);

        container.addEventListener('mouseover', () => {
            clearInterval(new_interval);
        });

        container.addEventListener('mouseout', () => {
            new_interval = setTimeout(() => {
                try {
                    if (document.getElementById("pypepro_nt_close_wrp_id")) {
                        document.getElementById("pypepro_nt_close_wrp_id").removeEventListener('click', handleOnCloseNotification)
                    }

                    let element_exist = document.getElementById("pypepro_notification_wrp_id");
                    if (element_exist) {
                        element_exist.remove();
                    }
                }
                catch (error) { }
            }, 1000);
        });

        if (redirect) {
            container.style.cursor = "pointer";
            container.addEventListener('click', (event) => {
                event.stopPropagation();
                clearInterval(new_interval);
                new_interval = '';
                container.classList.add('pypepro_nt_hide');
                onClose();
                window.open(redirect, "_self");
            });
        }

        container.setAttribute('interval', new_interval)
    }
}

export const NotificationHtmlTemplateV2 = ({

    classText = 'pypepro_notification_wrp_class_v2',
    headerText = 'Notice Lead Owner Change',
    bodyText,
    closeBtnText = '',
    timer = 3000,
    closeButtonLink = null,
    leftIcon = '',
    redirect = null,
    onClose = () => { }
}) => {

    let new_interval = '', container = '';
    function handleCloseButtonClick(event) {
        event.stopPropagation();
        clearInterval(new_interval)
        new_interval = ''
        container.classList.add('pypepro_nt_hide');
        onClose();

        if (closeButtonLink) {
            window.location.href = closeButtonLink;
        }
    }

    function closeNotification(event) {
        event.stopPropagation();
        clearInterval(new_interval)
        new_interval = ''
        container.classList.add('pypepro_nt_hide');
        onClose();
    }

    removeNotification();
    const elm = `
        <div class="pypepro_nt_left_wrp" id="pypepro_nt_left_wrp_id">
            <h6 class="pypepro_nt_header">${headerText}</h6>
            <p class="pypepro_nt_body">${bodyText}</p>

            ${closeBtnText && `<button class="pypepro_nt_close" id="pypepro_nt_close_wrp_id">${closeBtnText}</button>`}
        </div>
      
    `
    container = document.createElement('div')
    container.className = "pypepro_notification_template"
    container.className = classText
    container.id = "pypepro_notification_wrp_id"
    container.innerHTML = elm
    document.body.appendChild(container)

    setTimeout(() => {
        container.classList.add('animate')
    }, 0);

    if (document.getElementById("pypepro_nt_close_wrp_id")) {
        document.getElementById("pypepro_nt_close_wrp_id").addEventListener('click', handleCloseButtonClick)
    }

    new_interval = setTimeout(() => {
        try {
            if (document.getElementById("pypepro_nt_close_wrp_id")) {
                document.getElementById("pypepro_nt_close_wrp_id").removeEventListener('click', closeNotification)
            }
            // container.classList.add('pypepro_nt_hide');
            let element_exist = document.getElementById("pypepro_notification_wrp_id");
            if (element_exist) {
                element_exist.remove();
            }
        }
        catch (error) { }
    }, timer);

    container.addEventListener('mouseover', () => {
        clearInterval(new_interval);
    });

    container.addEventListener('mouseout', () => {
        new_interval = setTimeout(() => {
            try {
                if (document.getElementById("pypepro_nt_close_wrp_id")) {
                    document.getElementById("pypepro_nt_close_wrp_id").removeEventListener('click', closeNotification)
                }

                let element_exist = document.getElementById("pypepro_notification_wrp_id");
                if (element_exist) {
                    element_exist.remove();
                }
            }
            catch (error) { }
        }, 1000);
    });

    // if (redirect) {
    //     container.style.cursor = "pointer";
    //     container.addEventListener('click', (event) => {
    //         event.stopPropagation();
    //         clearInterval(new_interval);
    //         new_interval = '';
    //         container.classList.add('pypepro_nt_hide');
    //         onClose();
    //         window.open(redirect, "_self");
    //     });
    // }

    container.setAttribute('interval', new_interval)

}

function removeNotification() {
    let element_exist = document.getElementById("pypepro_notification_wrp_id");
    if (element_exist) {
        element_exist.remove();
    }
}

const isValidURL = (url) => {
    const pattern = new RegExp(
        "^(https?:\\/\\/)?" + // protocol
        "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
        "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
        "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
        "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
        "(\\#[-a-z\\d_]*)?$",
        "i"
    ); // fragment locator
    return !!pattern.test(url);
};

const isValidEmail = (email) => {
    //eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

const isValidMobileNumber = (mobileNumber) => {

    if (mobileNumber !== '' && mobileNumber.length < 10) {
        return false;
    } else if (mobileNumber !== '' && mobileNumber.length > 11) {
        return false;
    } else if (mobileNumber.length === 11 && mobileNumber.substring(0, 1) !== '1') {
        return false;
    }
    return true;
}

export const getState = (value) => US_STATE_LIST.find((state) => state.value === value)?.label;

const validateEmail = (email) => {
    // eslint-disable-next-line no-useless-escape
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

const validateMobileNumber = (mobileNumber) => {

    if (mobileNumber !== '' && mobileNumber.length < 10) {
        return false;
    } else if (mobileNumber !== '' && mobileNumber.length > 11) {
        return false
    } else if (mobileNumber.length === 11 && mobileNumber.substring(0, 1) !== '1') {
        return false;
    }
    return true
}

export const cleanNumber = (number) => {
    try {
        if (isNaN(number)) {
            return "x.xx";
        }

        if (typeof number === "string") {
            number = parseFloat(number);
        }

        const parts = number.toString().split(".");
        if (parts.length === 1) {
            return number.toFixed(2).replace(/\.0*$/, "") + ".00";
        }
        const decimalPart = parts[1].length < 2 ? parts[1] + "0" : parts[1];
        return `${parts[0]}.${decimalPart}`;
    } catch (err) {
        return "x.xx";
    }
}

export const toRegular = (text) => {
    try {
        const modText = text.replace(/([A-Z])/g, " $1");
        return modText.charAt(0).toUpperCase() + modText.slice(1);
    } catch (err) {
        return text;
    }
}

export const padZero = (value) => {
    return value < 10 ? `0${value}` : value;
}

export const toHuman = (text) => {
    if (typeof text === "boolean") {
        return text === true ? "Yes" : "No";
    }

    return text;
}

export const isDeleteAble = (object, which) => {
    if (which === "email") {
        return !!object["number"];
    }

    if (which === "number") {
        return !!object["email"];
    }
};

export const toLowerCase = (value) => {
    try {
        return value.toLowerCase();
    } catch (e) {
        return value;
    }
}

export const setNumberType = (value) => {
    try {
        let list = [PHONE_STATE.mobile, PHONE_STATE.landline, PHONE_STATE.voip, PHONE_STATE.unknown];

        if (value && typeof value === "string") {
            value = value.toLowerCase();
        }

        if (value && list.includes(value)) {
            return value
        }

        return PHONE_STATE.unknown;
    } catch (er) {
        return PHONE_STATE.unknown;
    }
}

export function formatPhoneNumber(phoneNumberString) {
    if (!phoneNumberString) {
        return 'N/A';
    }

    if (phoneNumberString.length < 11) {
        phoneNumberString = '1' + phoneNumberString;
    }
    return phoneNumberString.replace(/\D+/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '+$1 ($2) $3-$4');
}

const validURL = (string) => {
    try {
        const regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
        return regexp.test(string);
    } catch (err) {
        return false;
    }
}

const calculateCash = (amount, fixedCount = 2) => {
    var flag = ''
    // 1000 = 1K
    // 1000000 = 1M = 1K * 1000
    // 1M * 1000 = 1B
    // 1B * 1000 = 1T
    if (amount >= 1000000000000000000000000) {
        amount = amount / 1000000000000000000000000
        flag = 'Y'
    }
    if (amount >= 1000000000000000000000) {
        amount = amount / 1000000000000000000000
        flag = 'Z'
    }
    if (amount >= 1000000000000000000) {
        amount = amount / 1000000000000000000
        flag = 'E'
    }
    if (amount >= 1000000000000000) {
        amount = amount / 1000000000000000
        flag = 'P'
    }
    if (amount >= 1000000000000) {
        amount = amount / 1000000000000
        flag = 'T'
    }
    else if (amount >= 1000000000) {
        amount = amount / 1000000000
        flag = 'B'
    }
    else if (amount >= 1000000) {
        amount = amount / 1000000
        flag = 'M'
    }
    else if (amount >= 1000) {
        amount = amount / 1000
        flag = 'K'
    }
    // return '$' + (Math.round(totalDeal * 100) / 100) + flag
    if (amount != null) {
        return '$' + amount.toFixed(fixedCount) + flag
    }
    return '$' + amount + flag
}

function formatCurrency(n, currency = "") {
    try {
        if (n !== "") {
            n = parseFloat(n);
        }

        if (typeof n !== "number" || isNaN(n)) return currency + Number(0).toFixed(2);
        const hasDecimal = n % 1 !== 0;

        return (
            currency +
            n.toFixed(hasDecimal ? 2 : 0).replace(/./g, function (c, i, a) {
                return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "," + c : c;
            })
        );
    } catch (err) {
        return n;
    }
}

export const checkScamMessage = (message) => {
    // List of suspicious keywords or phrases commonly found in scam messages

    // Regular expression to detect URLs in the message
    const urlRegex = /https?:\/\/[^\s/$.?#].[^\s]*/gi;

    // Convert message to lowercase for case-insensitive comparison
    const messageLower = message.toLowerCase();

    // Check for suspicious keywords
    const containsScamKeyword = SCAM_KEYWORDS.some(keyword => messageLower.includes(keyword));

    // Check for URLs in the message
    const containsUrl = urlRegex.test(message);

    // If message contains a suspicious keyword or URL, it might be a scam
    if (containsScamKeyword || containsUrl) {
        return true; // Potential scam
    }
    return false;
}

const setPlainCookie = (name, value, min) => {
    let date = new Date();
    date.setTime(date.getTime() + (min * 60 * 1000));
    let expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
}

const getPlainCookie = (name) => {
    let cookieArr = document.cookie.split(";");

    for (let i = 0; i < cookieArr.length; i++) {
        let cookie = cookieArr[i].trim();
        if (cookie.indexOf(name + "=") === 0) {
            return cookie.substring(name.length + 1, cookie.length);
        }
    }
    return null;
}

const removeQueryParam = (paramsToRemove) => {
    const url = new URL(window.location.href);
    const searchParams = url.searchParams;

    paramsToRemove.forEach((param) => searchParams.delete(param));

    let newUrl = url.pathname;
    if (searchParams && searchParams.size !== 0) {
        newUrl += `?${searchParams.toString()}`;
    }
    window.history.replaceState(null, '', newUrl);
};

const isMicrophoneOn = async (reason = 'Outgoing') => {
    try {
        // Request permissions for microphone access
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        // If we get a stream, the microphone is enabled
        console.log('Microphone is ON.');
        stream.getTracks().forEach((track) => track.stop()); // Stop the stream after checking
        return true;
    } catch (error) {
        // If there's an error, the microphone is either disabled or permission is denied
        if (error.name === 'NotAllowedError') {
            alert(
                reason === 'Outgoing' ? 'Microphone access is blocked. Please enable it'
                    : 'Microphone access is blocked. Please enable before receive call'
            );
        } else if (error.name === 'NotFoundError') {
            alert(
                reason === 'Outgoing' ? 'No microphone is detected. Please enable it Before'
                    : 'Microphone access is blocked. Please enable before receive call'
            );
            alert('No microphone is detected. Please check your device.');
        } else {
            console.error('Error accessing microphone:', error);
        }
        return false;
    }
}
// Helper function to set a cookie with expiry
function setCookieForModalClose(key, value, ttlInMilliseconds) {
    const expires = new Date(Date.now() + ttlInMilliseconds).toUTCString();
    document.cookie = `${key}=${value}; expires=${expires}; path=/`;
  }
  
  // Helper function to get a cookie value
  function getCookieForModalOpen(key) {
    const name = `${key}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(";");
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return null;
  }
  export const ONE_DAY_MS = 24 * 60 * 60 * 1000; // 24 hours in milliseconds

const generateRandomString = (length) => {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
}

export const updateCookieData = (needle, value) => {

    let accountData = null;
    let check_new = getCookie("encode__process__new")
    if (check_new !== undefined) {
        accountData = getCookieLogin(process.env.REACT_APP_ACCOUNT_DATA);
    } else {
        accountData = getCookie(process.env.REACT_APP_ACCOUNT_DATA);
    }
    if (accountData) {
        accountData = JSON.parse(accountData);
        accountData[needle] = value;
    }
    setCookieLogin(process.env.REACT_APP_ACCOUNT_DATA, JSON.stringify(accountData), process.env.REACT_APP_ACCESS_TOKEN_VALIDITY);
}

const cleanPhoneNumber = (number) => {
    return number.replace(/[+\-()\s]/g, '');
}

const isNumeric = (str) => {
    return /^\d+$/.test(str);
}

const fixDecimal = (number, digit = null) => {
    try{
        if(isNaN(number)){
            return "0.00";
        }

        if (typeof number === "string") {
            number = parseFloat(number);
        }

        const parts = number.toString().split('.');
        if (parts.length === 1) {
            return number.toFixed(digit ?? 2).replace(/\.0*$/, '') + '.00';
        }

        if (digit !== null) {
            return number.toFixed(digit);
        }

        const decimalPart = parts[1].length < 2 ? parts[1] + '0' : parts[1];
        return `${parts[0]}.${decimalPart}`;
    }catch(err){
        return "0.00";
    }
};

const convertArrayToIdObject = (array) => {
  try {
    if (!Array.isArray(array)) return {};

    const map = {};
    for (let i = 0; i < array.length; i++) {
      const item = array[i];
      if (item && item.id) {
        map[item.id] = item;
      }
    }
    return map;
  } catch {
    return {};
  }
};

/**
 * Utility helper
 */
const Utils = {
    setCookieForModalClose,
    getCookieForModalOpen,
    handleException,
    getContactDisplayName,
    getInitial,
    validateEmail,
    validateMobileNumber,
    generateTimezoneList,
    showNotification,
    formatNumber,
    loadSocket,
    getAccountData,
    getShorterText,
    loadCodeSnippets,
    referralTrackingScript,
    getIconTextFromContact,
    isEmpty,
    getContactName,
    reduceTextLength,
    setAgencyTitleAndFav,
    checkLetterExistInText,
    checkNumberExistInText,
    isNaturalNumber,
    create_UUID,
    FileDownloadNotificationHtmlTemplate,
    NotificationHtmlTemplate,
    isValidURL,
    isValidEmail,
    isValidMobileNumber,
    validURL,
    calculateCash,
    formatCurrency,
    setPlainCookie,
    getPlainCookie,
    removeQueryParam,
    isMicrophoneOn,
    generateRandomString,
    updateCookieData,
    cleanPhoneNumber,
    isNumeric,
    fixDecimal,
    convertArrayToIdObject
}

export default Utils;